/**
 * Texts for FAQs page
 */
export const faqPageText = {
    title: 'Was ist CamAPS FX',
    titleMeta: 'Haben Sie eine Frage zu CamAPS FX?',
    descriptionMeta: 'Hier sind die Antworten auf einige Ihrer häufig gestellten Fragen ' +
        'zu kompatiblen Geräten, behördlicher Zulassung, Verfügbarkeit und klinischer Forschung',
    keywords:
        'camaps faqs deutschland, camaps fx faqs deutschland, ' +
        // 'closed loop, closed loop system, loop deutsch, eine autoimmunerkrankung kommt selten allein, glukose im blut, closed de, open loop closed loop, loop diabetes, was ist ein loop, hba1c zu niedrig, blutglukose, closed loop diabetes, dexcom app, insulin berechnen app, closed loop insulinpumpe, diabetes zimt therapie, glukose zu hoch, stopp diabetes, dexcom g6 closed loop, diabetes kohlenhydrate app, hybrid closed loop diabetes, loop dexcom g6, welche insulinpumpen gibt es, diabetes loop system, kohlenhydrate app android, kur diabetes typ 1, was heißt loop, mutter kind kur für diabetiker,  ' +
        '',
    localeMeta: 'de_de',

    haveQuestion: 'Haben Sie eine Frage zu CamAPS FX?',
    hereAnswers: 'Hier sind die Antworten zu einigen häufig gestellten Fragen.',
    whatIsCamAPS: 'Was ist CamAPS FX?',
    whatIsCamAPSAnswer: 'CamAPS FX ist eine über einen Zeitraum von mehr als 10 Jahren entwickelte, benutzerfreundliche Applikation zur automatischen Insulindosierung (Hybrid Closed Loop) bei Menschen mit Typ-1-Diabetes (ab dem 1. Lebensjahr).',
    isApproved: 'Ist CamAPS FX zugelassen?',
    isApprovedAnswer: 'Die App wurde umfassend in klinischen Studien geprüft und ist in einer Reihe von Ländern und Regionen für die Anwendung zugelassen, darunter Australien, Kanada, die Europäische Union, Neuseeland, Norwegen, die Schweiz, das Vereinigte Königreich und die Vereinigten Staaten.',
    isAvailable: 'Gibt CamAPS FX in meiner Region?',
    isAvailableAnswer1: 'CamAPS FX ist in ausgewählten Diabeteskliniken verfügbar und für Privatzahler, die ein Online-Training absolvieren. Bitte halten Sie Rücksprache mit Ihrer Klinik oder gehen Sie zu',
    isAvailableAnswer2: 'Bestellung',
    isAvailableAnswer3: 'der App.',
    whatIsLiberty: 'Was ist CamAPS Liberty?',
    whatIsLibertyAnswer: 'CamAPS Liberty ist eine Funktion innerhalb von CamAPS FX. Wenn sie aktiviert ist, müssen Benutzer vor Mahlzeiten und Snacks keine Kohlenhydrate zählen und keinen Bolus abgeben.',
    whatIsLibertyMoreInfo1: 'Weitere Informationen finden Sie auf unserer ',
    whatIsLibertyPageLink: 'CamAPS Liberty-Seite',
    whatIsLibertyMoreInfo2: ' oder laden Sie dieses ',
    whatIsLibertyFactsheetLink: 'Informationsblatt',
    whatIsLibertyMoreInfo3: ' herunter.',
    whatIsLibertyFactsheetUrl: '#',
    cost: 'Was kostet CamAPS FX?',
    costAnswer1: 'Für Details zu den Kosten gehen Sie bitte zu',
    costAnswer2: 'Bereich der Webseite.',
    compatibleCgm: 'Welche CGMs sind mit CamAPS FX kompatibel?',
    compatibleCgmBody: 'CamAPS FX ist kompatibel mit Dexcom G6, Dexcom G7, FreeStyle Libre 3 und FreeStyle Libre 3 Plus. Bitte klicken Sie auf die Links, um die kompatiblen Smartphones und Betriebssysteme anzuzeigen.',
    whatPumps: 'Welche Insulinpumpen sind mit CamAPS FX kompatibel?',
    whatPumpsAnswer1: 'CamAPS FX ist im Google Play Store und im Apple App Store mit YpsoPump-Insulinpumpen kompatibel.',
    whatPumpsAnswer2: '',
    whatPumpsAnswer3: '',
    whatPumpsAnswerHtml: 'https://www.ime-dc.de/de/insulintherapie/insulinpumpen/insulinpumpe-dana-rs',
    whatPhone: 'Welche Smartphones sind mit CamAPS FX kompatibel?',
    whatPhoneAnswer: 'Ihr Smartphone muss mit dem von Ihnen verwendeten CGM kompatibel sein.',
    cgmManufacturerListText: 'Bitte überprüfen Sie die Kompatibilitätsliste des Herstellers Ihres CGM für Dexcom G6, Dexcom G7, FreeStyle Libre 3 oder FreeStyle Libre 3 Plus.',
    whatOperating: 'Welche Betriebssysteme sind mit CamAPS FX kompatibel?',
    whatOperatingAnswer: 'CamAPS FX unterstützt Android 13 bis 16 und iOS 18 bis 27, einschließlich nachfolgender Minor-Versionen. Ihr Betriebssystem muss außerdem mit dem von Ihnen verwendeten CGM kompatibel sein.',
    whatOperatingManufacturerText: 'Bitte überprüfen Sie die Kompatibilitätsliste des Herstellers Ihres CGM für Dexcom G6, Dexcom G7, FreeStyle Libre 3 oder FreeStyle Libre 3 Plus.',
    whatPhoneAnswerDexcomHtml:'https://www.dexcom.com/en-GB/compatibility/g6',
    whatPhoneAnswerDexcomG7Html:'https://www.dexcom.com/en-GB/compatibility/g7',
    whatPhoneAnswerLibreHtml:'https://freestyleserver.com/Payloads/IFU/2026/q2/ART43193-006_rev-AP-pub.pdf',

    whereUpload: 'Wohin kann ich meine Daten von der CamAPS FX hochladen?',
    whereUploadAnswer: 'Derzeit können Daten von der CamAPS FX hochgeladen werden nach mylife Cloud und Glooko.',
    whatLanguage: 'In welchen Sprachen steht CamAPS FX zur Verfügung?',
    whatLanguageAnswer: 'CamAPS FX steht auf Englisch, Tschechisch, Dänisch, Niederländisch, Französisch, Finnisch, Deutsch, Italienisch, Norwegisch, Polnisch, Spanisch und Schwedisch zur Verfügung.',
    whereResults: 'Wo kann ich die Resultate der klinischen Studien finden?',
    whereResultsAnswer1: 'Publikationen zum Einsatz des Cambridge Control Algorithmus stehen zum Download zur Verfügung',
    whereResultsAnswer2: 'hier.',
    whereResultsAnswer3: 'Zentrale Publikationen wurden veröffentlicht in',
    whereResultsAnswer4: 'und',

    wantMoreInfoIOS: 'Möchten Sie mehr über die CamAPS FX iOS-App erfahren?',
    wantMoreInfoIOSanswer1: '',
    wantMoreInfoIOSanswer2: 'Klicken Sie hier,',
    wantMoreInfoIOSanswer3: 'um mehr zu erfahren.',
    wantMoreInfoIOSanswerHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/iOS+FAQ_DE_005.pdf',

    wantMoreInfoCGManswerHtml: 'https://s3.eu-west-1.amazonaws.com/admin.camdiab.com/faq.info/Sensor_FAQs_DE.pdf',
};

